import React from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import WelcomePopup from './components/WelcomePopup';
import Home from './pages/Home';
import MarketingTools from './pages/MarketingTools';
import Analytics from './pages/Analytics';
import AboutUs from './pages/AboutUs';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import WhiteLabelSEO from './pages/WhiteLabelSEO';
import WhiteLabelMarketing from './pages/WhiteLabelMarketing';
import SEOService from './pages/SEOService';
import SEOAdmin from './pages/SEOAdmin';
import WebDevelopmentService from './pages/WebDevelopmentService';
import ChatGPTListing from './pages/ChatGPTListing';
import GMBOptimization from './pages/GMBOptimization';
import AIAutomationTools from './pages/AIAutomationTools';
import PrivacyPolicy from './pages/PrivacyPolicy';
import BookSlot from './pages/BookSlot';
import DigitalMarketing from './pages/DigitalMarketing';
import NotFound from './pages/NotFound';
import BlogIndex from './pages/BlogIndex';
import BlogDetail from './pages/BlogDetail';
import TeamMemberDetail from './pages/TeamMemberDetail';
import SouthAfricaSEO from './pages/SouthAfricaSEO';

function App() {
  const isNoIndexDomain = typeof window !== 'undefined' && window.location.hostname.includes('xdmedia.agency');

  return (
    <HelmetProvider>
      {isNoIndexDomain && (
        <Helmet>
          <meta name="robots" content="noindex, nofollow, noarchive" />
        </Helmet>
      )}
      <Router>
        <ScrollToTop />
        <WelcomePopup />
        <Layout>
          <Routes>
            <Route path="/" element={<DigitalMarketing />} />
            <Route path="/2" element={<Home />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/seo-guide-for-businesses" element={<BlogDetail slug="seo-guide-for-businesses" />} />
            <Route path="/seo-vs-aeo-vs-geo" element={<BlogDetail slug="seo-vs-aeo-vs-geo-chatgpt-ai-overviews" />} />
            <Route path="/website-design" element={<MarketingTools />} />
            <Route path="/performance-marketing" element={<Analytics />} />
            <Route path="/white-label-seo" element={<WhiteLabelSEO />} />
            <Route path="/white-label-digital-marketing" element={<WhiteLabelMarketing />} />
            <Route path="/seo-service" element={<SEOService />} />
            <Route path="/affordable-seo-services-in-india" element={<SEOService />} />
            <Route path="/affordable-seo-services-south-africa" element={<SouthAfricaSEO />} />
            <Route path="/web-development-services" element={<WebDevelopmentService />} />
            <Route path="/web-development-company-india" element={<WebDevelopmentService />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/team/:memberId" element={<TeamMemberDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/seo-leads" element={<SEOAdmin />} />
            <Route path="/ai-search-visibility" element={<ChatGPTListing />} />
            <Route path="/gmb-optimization" element={<GMBOptimization />} />
            <Route path="/ai-automation-tools" element={<AIAutomationTools />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/book-a-slot" element={<BookSlot />} />
            <Route path="/digital-market" element={<DigitalMarketing />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </Router>
    </HelmetProvider>
  );
}

export default App;
